import type { AsesInstrumentConfig, AsesQuestion } from './proInstrument';
import { shouldRenderOksForm } from './proInstrument';
import { WpLeadWidget } from '../contexts/lead';
import { WpSlideWidget } from '../contexts/pitch';
import {
  type OxfordAnswers,
  isOxfordQuestionAnswered,
  canAdvanceFromOxfordQuestion,
  areAllOxfordQuestionsAnswered,
  buildOxfordLeadValues,
  buildOxfordApiValues,
  parseOxfordAnswers,
  areCampaignOxfordWidgetsComplete,
  transformOxfordWidgetValuesForSubmit,
} from './oxfordSubmit';

export type OksAnswers = OxfordAnswers;

export const isOksQuestionAnswered = isOxfordQuestionAnswered;
export const canAdvanceFromOksQuestion = canAdvanceFromOxfordQuestion;
export const areAllOksQuestionsAnswered = areAllOxfordQuestionsAnswered;
export const buildOksLeadValues = buildOxfordLeadValues;
export const buildOksApiValues = buildOxfordApiValues;
export const parseOksAnswers = parseOxfordAnswers;

export function areCampaignOksWidgetsComplete(
  widgets: WpSlideWidget[],
  leadWidgets: WpLeadWidget[],
): boolean {
  return areCampaignOxfordWidgetsComplete(widgets, leadWidgets, shouldRenderOksForm);
}

export function transformOksWidgetValuesForSubmit(
  leadWidgets: WpLeadWidget[],
  campaignWidgets: WpSlideWidget[],
): WpLeadWidget[] {
  return transformOxfordWidgetValuesForSubmit(leadWidgets, campaignWidgets, shouldRenderOksForm);
}

export type { AsesInstrumentConfig, AsesQuestion };
